export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}

export enum ExpressPaymentMethods {
    gpay = 'gpay',
    paypal = 'paypal',
}

export enum StatsigSynchronousInitializationExperimentVariant {
    unknown = 'unknown',
    control = 'control',
    test = 'test',
}

export enum PostCheckoutMandatoryAllQuestionsVariant {
    optionalAndCannedQuestions = 'optionalAndCannedQuestions',
    allQuestions = 'allQuestions',
}

export enum FollowCardPlacementExperimentVariant {
    bottomFollowCard = 'bottom',
    topFollowCard = 'top',
}

export enum SHARE_TYPES {
    FACEBOOK = 'facebook',
    FACEBOOK_MESSENGER = 'facebookMessenger',
    TWITTER = 'twitter',
    EMAIL = 'email',
}

export enum ConfirmationPageReferralExperimentVariant {
    control = 'control',
    referralDrawer = 'referralDrawer',
    referralLinkout = 'referralLinkout',
}
